export enum EFloodlightHologramBuildStep {
  FHBS_PlacementAndRotation,
  FHBS_AdjustAngle,
}
